import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import { production_chart, room_types_chart, adr_chart } from "../widgets/Charts";
import Helpers, { windowsActive } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";
import axios from "axios";

class Production extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            months          : "",
            general_result  : "",
            month_result    : "",
            month_keys      : {},
            totals          : {
                adr_bb_by_widget: 0,
                adr_books_by_widget: 0,
                adr_budget_by_widget: 0,
                adr_ly_by_widget: 0,
                reservations_by_widget: 0,
                reservations_ly_by_widget: 0,
                revenue_bb_by_widget: 0,
                revenue_budget_by_widget: 0,
                revenue_by_widget: 0,
                revenue_by_widget_ly: 0,
                room_nights_bb_by_widget: 0,
                room_nights_books_by_widget: 0,
                room_nights_budget_by_widget: 0,
                room_nights_by_widget_ly: 0
            }
        }
    }

    getOptionTypeBar = (chart) => {
        let char_keys = Object.keys(this.props.response_request);

        let xAxis = [], 
        current_year_values = [], 
        last_year_value = [], 
        budget = [];

        let $self = this;
        let result
        if (char_keys.length > 0){
            if(chart === "data_reserves_production"){
                result    = this.props.response_request["data_production_widget"];
                xAxis     = Object.keys(result) 
                Object.keys(result).map(function(key, index){
                    budget[index]                 = result[key]["budget"];
                    current_year_values[index]    = result[key]["current_year_value"];
                    last_year_value[index]        = result[key]["last_year_value"];
                })
            }
        }
        return production_chart(xAxis, budget, current_year_values, last_year_value, [$self.props.current_year, $self.props.past_year], $self.props.view_results);
    }

    setStateMonth(key){
        let $self = this;
        Object.keys(this.state.month_keys).map(function(key_aux){
            let month_keys_aux  = $self.state.month_keys;
            if(key_aux !== key){
                month_keys_aux[key_aux].state = "inactive";
            }
            $self.setState({
                month_keys : month_keys_aux
            })
        });

        let month_keys_aux      = this.state.month_keys;

        if(month_keys_aux[key].state === "inactive"){
            month_keys_aux[key].state = "active";
            this.setState({
                month_list : {
                    status : "active",
                    key : key
                }
            })
        }else{
            month_keys_aux[key].state = "inactive";
            this.setState({
                month_list : {
                    status : "inactive",
                    key : key
                }
            })
        }
        this.setState({
            month_keys : month_keys_aux
        })
    }

    componentWillReceiveProps(props){
        
        let char_keys = Object.keys(props.response_request);
        let $self = this;
        let result, totals;
        if (char_keys.length > 0){

            result  = props.response_request["data_production_year"]["result"]
            totals  = props.response_request["data_production_year"]["totals"]
            
            $self.setState({
                month_keys : result
            });

            $self.setState({
                totals : totals
            });
        }
    }

    render() {
        let $self = this, 
        months,
        current_year_production = [],
        last_year_production = [],
        current_year_budget = [],
        budget_vs_production = []; 

        months = Object.keys($self.state.month_keys).map((key, index) => 
            <div key={"list-months-"+index} className={"column-grid " + (index % 2 ? "row-c " : "") + $self.state.month_keys[key].state}>
                <div className="row-grid">{ key }</div>
            </div>
        )

        current_year_production = Object.keys($self.state.month_keys).map((key, index) => 
            <div key={"list-current-year-production-"+index} className={"column-grid " + (index % 2 ? "row-c " : "") + $self.state.month_keys[key].state}>
                <div className="row-grid reserve-production rn">{ $self.state.month_keys[key].total_room_nights }</div>
                <div className="row-grid reserve-production rv">${ $self.state.month_keys[key].total_reservations }</div>
                <div className="row-grid reserve-production adr">${ $self.state.month_keys[key].adr_books }</div>
            </div>
        )

        last_year_production = Object.keys($self.state.month_keys).map((key, index) => 
            <div key={"list-past-year-production-"+index} className={"column-grid " + (index % 2 ? "row-c " : "") + $self.state.month_keys[key].state}>
                <div className="row-grid reserve-production rn">{ $self.state.month_keys[key].total_room_nights_ly }</div>
                <div className="row-grid reserve-production rv">${ $self.state.month_keys[key].total_reservations_ly }</div>
                <div className="row-grid reserve-production adr">${ $self.state.month_keys[key].adr_ly }</div>
            </div>
        )

        current_year_budget = Object.keys($self.state.month_keys).map((key, index) => 
            <div key={"list-current-year-budget-"+index} className={"column-grid " + (index % 2 ? "row-c " : "") + $self.state.month_keys[key].state}>
                <div className="row-grid reserve-production rn">{ $self.state.month_keys[key].budget_room_nights }</div>
                <div className="row-grid reserve-production rv">${ $self.state.month_keys[key].budget_revenue }</div>
                <div className="row-grid reserve-production adr">${ $self.state.month_keys[key].adr_budget }</div>
            </div>
        )

        budget_vs_production = Object.keys($self.state.month_keys).map((key, index) => 
            <div key={"list-budget-production-"+index} className={"column-grid " + (index % 2 ? "row-c " : "") + $self.state.month_keys[key].state}>
                <div className="row-grid reserve-production rn percent">{ $self.state.month_keys[key].book_vs_budget_room_night }%</div>
                <div className="row-grid reserve-production rv percent">{ $self.state.month_keys[key].book_vs_budget_revenue }%</div>
                <div className="row-grid reserve-production adr percent">{ $self.state.month_keys[key].adr_book_vs_budget }%</div>
            </div>
        )
        return (
            <section>
                <div className={"datagrid-widget production-year"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCTION</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    <ReactEcharts
                                        option={windowsActive(this.props, "reservation", "production") === true ? this.getOptionTypeBar("data_reserves_production") : {} }
                                        notMerge={true}
                                        lazyUpdate={true}
                                        theme={"theme_name"}
                                        
                                        onChartReady={this.onChartReadyCallback}
                                    />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget list-years"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title year">MONTHS</span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    {months}
                                    <div className={"column-grid totals"}>
                                        <div className="row-grid">TOTAL</div>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget list-result-nights"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCTION {this.props.current_year}</span>
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid reserve-production rn">R/N</span>
                                    <span className="row-grid reserve-production rv">REVENUE</span>
                                    <span className="row-grid reserve-production adr">ADR</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    {current_year_production}
                                    <div className={"column-grid totals"}>
                                        <span className="row-grid reserve-production rn">{this.state.totals.room_nights_books_by_widget}</span>
                                        <span className="row-grid reserve-production rv">${this.state.totals.revenue_by_widget}</span>
                                        <span className="row-grid reserve-production adr">${this.state.totals.adr_books_by_widget}</span>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget list-result-nights"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">BUDGET</span>
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid reserve-production rn">R/N</span>
                                    <span className="row-grid reserve-production rv">REVENUE</span>
                                    <span className="row-grid reserve-production adr">ADR</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    {current_year_budget}
                                    <div className={"column-grid totals"}>
                                        <span className="row-grid reserve-production rn">{this.state.totals.room_nights_budget_by_widget}</span>
                                        <span className="row-grid reserve-production rv">${this.state.totals.revenue_budget_by_widget}</span>
                                        <span className="row-grid reserve-production adr">${this.state.totals.adr_budget_by_widget}</span>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget list-result-nights"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">REACH</span>
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid reserve-production rn percent">R/N</span>
                                    <span className="row-grid reserve-production rv percent">REVENUE</span>
                                    <span className="row-grid reserve-production adr percent">ADR</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    {budget_vs_production}
                                    <div className={"column-grid totals"}>
                                        <span className="row-grid reserve-production rn percent">{this.state.totals.room_nights_bb_by_widget}%</span>
                                        <span className="row-grid reserve-production rv percent">{this.state.totals.revenue_bb_by_widget}%</span>
                                        <span className="row-grid reserve-production adr percent">{this.state.totals.adr_bb_by_widget}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget list-result-nights"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCTION {this.props.past_year}</span>
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid reserve-production rn">R/N</span>
                                    <span className="row-grid reserve-production rv">REVENUE</span>
                                    <span className="row-grid reserve-production adr">ADR</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    {last_year_production}
                                    <div className={"column-grid totals"}>
                                        <span className="row-grid reserve-production rn">{this.state.totals.room_nights_by_widget_ly}</span>
                                        <span className="row-grid reserve-production rv">${this.state.totals.revenue_by_widget_ly}</span>
                                        <span className="row-grid reserve-production adr">${this.state.totals.adr_ly_by_widget}</span>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
            </section>
        )
    }
}

export default Production



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/Production.js